import React, { FC } from 'react';
import { Settings, Zap } from 'lucide-react';
import styles from './index.module.css';
import cx from 'classnames';
import { Button } from 'antd';
import premiumFeatureImage from './images/img-upgrade-integrations.jpg';
import ArrowUp from './images/ic-upgrade-circle.svg';
import UpgradePopover from '../../../../clients/sidebar/components/UpgradePopover';
import { onArticleClick } from '../../utils/HelpArticleButton';

type Props = {
  mobileView?: boolean;
  name: string;
  link: string;
  articleId: string;
  video: boolean;
  isConnectedButton: boolean;
  isPremiumIntegration: boolean;
  integrationName: string;
  enabled: boolean;
  buttonDisabled: boolean;
  onButtonClick: () => void;
  isTrialUser: boolean;
  premiumIntegrationsAllowed: boolean;
  setPopOverToShow: (integrationName: string) => void;
  popOverToShow: string;
  ownerEmail: string;
  bugherdUrl: string;
  organizationId: string;
  setShowPreview: (showPreview: string) => void;
};

export const IntegrationActions: FC<Props> = ({
  mobileView,
  name,
  link,
  articleId,
  video,
  isConnectedButton,
  isPremiumIntegration,
  integrationName,
  enabled,
  buttonDisabled,
  onButtonClick,
  isTrialUser,
  premiumIntegrationsAllowed,
  setPopOverToShow,
  popOverToShow,
  ownerEmail,
  bugherdUrl,
  organizationId,
  setShowPreview
}) => {
  return (
    <div
      className={cx(styles.integrationActions, {
        [styles.mobileActionsView]: mobileView
      })}
    >
      {isPremiumIntegration && (isTrialUser || !premiumIntegrationsAllowed) && (
        <UpgradePopover
          isSmallView={false}
          open={popOverToShow === name}
          onOpenChange={() => setPopOverToShow('')}
          message={
            <p className={styles.upgradeMessage}>
              {isTrialUser
                ? 'This integration is enabled for your free trial but requires upgrading after that.'
                : 'To connect this integration, please upgrade your plan.'}
            </p>
          }
          placement="topRight"
          className={styles.upgradePopover}
          getContainer={() =>
            // @ts-expect-error
            document.getElementById('integration-popover')
          }
          imageSrc={premiumFeatureImage}
          billingRights
          ownerEmail={ownerEmail}
          href={`${bugherdUrl}/organizations/${organizationId}/subscription`}
        >
          <ArrowUp
            className={styles.upgradeArrow}
            onClick={() => setPopOverToShow(integrationName)}
          />
        </UpgradePopover>
      )}
      {(link || articleId) && (
        <Button
          type="text"
          className={styles.guideButton}
          href={link}
          target={link ? '_blank' : undefined}
          onClick={e => {
            const isVideo = video && link;
            if (articleId || isVideo) {
              e.preventDefault();
              e.stopPropagation();
              if (articleId) {
                onArticleClick({ articleId });
              } else if (isVideo) setShowPreview(link);
            }
          }}
        >
          {video ? 'See it in action' : 'Overview'}
        </Button>
      )}
      <Button
        type={isConnectedButton ? 'default' : 'primary'}
        className={cx({
          [styles.connectButton]: !isConnectedButton
        })}
        onClick={onButtonClick}
        disabled={buttonDisabled}
        icon={
          enabled ? (
            <Settings className={styles.connectedButtonIcon} />
          ) : (
            <Zap className={styles.disconnectedButtonIcon} />
          )
        }
      >
        <span className={styles.upgradePlanIcon} />
        <span className={styles.buttonText}>
          {enabled ? 'Manage' : 'Connect'}
        </span>
      </Button>
    </div>
  );
};
